import widgetLoader from 'dibs-widget-loader';

let klarnaSdkPromise: Promise<void> | null = null;
export function initKlarnaSdk(clientToken: string): Promise<void> {
    if (!klarnaSdkPromise) {
        klarnaSdkPromise = new Promise(resolve => {
            window.klarnaAsyncCallback = () => {
                window.Klarna.Payments.init({
                    client_token: clientToken,
                });
                resolve();
            };
            widgetLoader.load('klarnaPayments');
        });
    }
    return klarnaSdkPromise;
}

export function loadKlarnaPaymentsWidget(container: string): Promise<boolean> {
    return new Promise(resolve => {
        window.Klarna.Payments.load(
            {
                container,
                payment_method_category: 'pay_over_time',
            },
            response => {
                resolve(!!response?.show_form);
            }
        );
    });
}

type KlarnaAuthorizeResult = {
    approved: boolean;
    showForm: boolean;
    finalizeRequired?: boolean;
    authorizationToken?: string;
};
export async function authorizeKlarnaPayment(): Promise<KlarnaAuthorizeResult> {
    return new Promise(resolve => {
        window.Klarna.Payments.authorize(
            { payment_method_category: 'pay_over_time', auto_finalize: false },
            {},
            response => {
                resolve({
                    approved: !!response?.approved,
                    showForm: !!response?.show_form,
                    finalizeRequired: !!response?.finalize_required,
                    authorizationToken: response?.authorization_token,
                });
            }
        );
    });
}

export async function reauthorizeKlarnaPayment(): Promise<KlarnaAuthorizeResult> {
    return new Promise(resolve => {
        window.Klarna.Payments.reauthorize(
            { payment_method_category: 'pay_over_time' },
            {},
            response => {
                resolve({
                    approved: !!response?.approved,
                    showForm: !!response?.show_form,
                    finalizeRequired: !!response?.finalize_required,
                    authorizationToken: response?.authorization_token,
                });
            }
        );
    });
}

type KlarnaFinalizeResult = {
    approved?: boolean;
    authorizationToken?: string;
};
export async function finalizeKlarnaPayment(): Promise<KlarnaFinalizeResult> {
    return new Promise(resolve => {
        window.Klarna.Payments.finalize({ payment_method_category: 'pay_over_time' }, response => {
            resolve({
                approved: !!response?.approved,
                authorizationToken: response?.authorization_token,
            });
        });
    });
}
